import apiClient from './client';
import type { AuthResponse, LoginCredentials, User } from '@/types';

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const { data } = await apiClient.post<AuthResponse>('/auth/login', credentials);
    return data;
  },

  async refresh(): Promise<{ token: string }> {
    const { data } = await apiClient.post<{ token: string }>('/auth/refresh');
    return data;
  },

  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  },

  async getMe(): Promise<User> {
    const { data } = await apiClient.get<User>('/comisionistas/me');
    return data;
  },
};
